<template>
  <div>
    <!-- Experience Map Modal -->
    <ExperienceMapModal
      v-if="showExperienceMap"
      :visible="showExperienceMap"
      :lodging="lodging"
      :focusedExperience="selectedExperienceForMap"
      @close="showExperienceMap = false">
    </ExperienceMapModal>
    <div class="container-label">
      <div class="banner-container" id="heroSection">
        <div class="row">
          <div class="col-md-4">
            <div
              class="address-content d-flex justify-content-center flex-column align-center text-center h-100 text-center" :class="isPhone ? 'pb-5' : ''">
              <p class="raleway-reg-p14" style="text-transform: uppercase;">{{ addressBook.destination }}</p>
              <h1 class="merriweather-reg-26">{{ addressBook.h1 }}</h1>
              <h2 class="raleway-reg-p15">{{ addressBook.description }}</h2>
              <div class="" :class="isPhone ? 'mb-5' : ''">
                <a :href="'/reservation-hotel/' + addressBook.lodging.slug" style="color: #3B6152; font-size: 16px;"
                  target="_blank">
                  En savoir plus
                  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg"
                    style="vertical-align: middle; margin-left: 5px;">
                    <path
                      d="M22.7132 6.26092L16.9354 0.122036C16.7909 -0.0224087 16.5743 -0.0224087 16.4298 0.122036C16.2854 0.26648 16.2854 0.483156 16.4298 0.6276L21.6298 6.15262H0.757595C0.540929 6.15262 0.396484 6.29706 0.396484 6.51373C0.396484 6.7304 0.540929 6.87484 0.757595 6.87484H21.5937L16.3937 12.3998C16.2493 12.5443 16.2854 12.797 16.3937 12.9054C16.5382 13.0498 16.7548 13.0498 16.8993 12.9054L22.677 6.76649C22.8215 6.58593 22.7854 6.36926 22.7132 6.26092Z"
                      fill="#3B6152" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="adddress-image">
              <img :src="addressBook.main_photo_url" :alt="addressBook.destination" />
            </div>
          </div>
          <div class="nav-lodging" :class="isPhone ? '' : 'ml-3'">
            <div class="menu-lodging">
              <div class="list-menu">
                <p class="menu-item raleway-bold-p15 my-1" :class="category.backend === 'Oenologiques' ? 'menu-item-no-border' : ''" v-for="category in categories" :key="category">
                  <a @click="scrollToElement(category.backend)">
                    {{ category.backend }}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="address-container">
      <div class="container-label">
        <div class="row">
          <div class="col-md-12">
            <div class="address-wrapper">
              <div class="row">
                <div class="col-md-5">
                  <div class="img-wrapper">
                    <img :src="addressBook.secondary_photo_url" alt="Le Carnet d'adresses d'Hortense" class="img-responsive  address-image" />
                    <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/circle.svg" alt="circle" class="circle-image position-absolute" />
                  </div>
                </div>
                <div class="col-md-5">
                  <div
                    class="address-content-wrapper d-flex justify-content-start flex-column align-center h-100 pl-4">
                    <h2 class="title-first merriweather-reg-26">Le Carnet d'adresses d'Hortense</h2>
                    <p class="raleway-reg-p15">
                      Hortense vous ouvre son carnet d'adresses pour faire de votre séjour une expérience unique
                      aventures culturelles, immersions en pleine nature, moments au bord de l'eau, découvertes
                      culinaires et œnologiques... Chaque expérience est pensée pour vous inspirer et enrichir votre
                      voyage, selon vos envies.
                    </p>
                    <div v-if="addressBook.html_content" class="html-content-wrapper">
                      <div
                        v-html="addressBook.html_content"
                        class="raleway-reg-p15 html-content"
                        :class="{ 'content-collapsed': !showFullContent }"
                      ></div>
                      <button
                        v-if="addressBook.html_content && addressBook.html_content.length > 200"
                        @click="toggleContent"
                        class="toggle-content-btn"
                      >
                        {{ showFullContent ? 'Afficher moins' : 'Afficher plus' }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="expe-btn">
              <a class="hortense-btn-primary" @click="showExperienceMapModal">Découvrez notre carte des expériences</a>
            </div>
            <ExperienceMapShow v-if="showMapfind" :currentLodging="this.addressBook.lodging" :markers="selectedExperienceMarker" @markerSelected="selectCard" :currentExperiance="currentExperiance" :lodgings="previous_lodging"
              @close="showMapfind = false"></ExperienceMapShow>
          </div>
        </div>
        <div class="row pt-5 mt-5" id="category-row">
          <div class="col-md-12">
            <div v-for="(experiences, category) in allExperiences" :key="category"
              :class="`my-5 category-wrapper ${classifyCategory(category)}`" v-if="experiences.length">
              <div class="desti-header text-center">
                <h2 class="title-first merriweather-reg-26">{{ category }} {{ addressBook.h2 }}</h2>
                <p class="raleway-reg-p15 mt-4">{{ categoryDescriptions[0] }}</p>
                <a @click="displayCategoryMap(category)" class="address-show"><i class="fas fa-map-marker-alt pr-2"></i>Voir sur la carte</a>
              </div>
              <div class="row mt-5">
                <CardExperienceCarnet v-for="experience in paginatedExperiences(category)" :key="experience.id"
                  :experience="experience" class="col-md-4 exp-card" @connection="$emit('connection')"
                  :user="isUserConnected()"
                  :category="category" @showOnMap="showExperienceOnMap"></CardExperienceCarnet>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="pagination-container text-center mt-5">
                    <button class="btn btn-outline-secondary" :disabled="currentPage[category] === 1"
                      @click="changePage(category, 1)">
                      « Premier
                    </button>
                    <button class="btn btn-outline-secondary" :disabled="currentPage[category] === 1"
                      @click="changePage(category, currentPage[category] - 1)">
                      ‹ Précédent
                    </button>

                    <button v-for="page in pageRange(category)" :key="page" class="btn"
                      :class="{ 'btn-success': currentPage[category] === page, 'btn-outline-secondary': currentPage[category] !== page }"
                      @click="changePage(category, page)">
                      {{ page }}
                    </button>

                    <button class="btn btn-outline-secondary" :disabled="currentPage[category] === totalPages(category)"
                      @click="changePage(category, currentPage[category] + 1)">
                      Suivant ›
                    </button>
                    <button class="btn btn-outline-secondary" :disabled="currentPage[category] === totalPages(category)"
                      @click="changePage(category, totalPages(category))">
                      Dernier »
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="map-container-exp">
      <div class="desti-header text-center pb-4">
        <h2 class="title-first merriweather-reg-26">La carte des expériences</h2>
        <p class="raleway-reg-p15 mt-4"> Découvrez notre carte interactive pour explorer les activités, découvertes et
          expériences uniques à vivre à proximité de notre établissement partenaire.</p>
      </div>
      <div class="container-label" :class="isPhone ? 'w-100' : ''">
        <ExperienceMap v-if="showMap" :markers="this.markers" :selectedExperience="this.selectedExperience"
                :lodgings="this.previous_lodging" :currentLodging="this.addressBook.lodging" @markerSelected="selectCardMap" :selectCardMap="selectCardMap"
                :selectCard="selectCard" @close="showMap = false"
                
                ></ExperienceMap>
      </div>
      <div class="container-label" id="map">
        <div class="col-md-12" id="map-wrapper">
          <div class="">
          </div>
          <div class="category-icon-wrapper">
            <ul class="icon-list">
              <li @click="filterExperiences('culturelles')"
                :class="activeCategories.includes('culturelles') ? 'li-active' : 'li-inactive'">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/museum.svg" alt="home1" />
              </li>
              <li @click="filterExperiences('culinaires')"
                :class="activeCategories.includes('culinaires') ? 'li-active' : 'li-inactive'">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/restaurant1.svg" alt="restaurant1" />
              </li>
              <li @click="filterExperiences('au bord de l\'eau')"
                :class="activeCategories.includes('au bord de l\'eau') ? 'li-active' : 'li-inactive'">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/restaurant1_group3.svg" alt="group3" />
              </li>
              <li @click="filterExperiences('au naturel')"
                :class="activeCategories.includes('au naturel') ? 'li-active' : 'li-inactive'">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/leaves.svg" alt="leaves" />
              </li>
              <li @click="filterExperiences('sportives')"
                :class="activeCategories.includes('sportives') ? 'li-active' : 'li-inactive'">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/sports1.svg" alt="sports1" />
              </li>
              <li @click="filterExperiences('immersives')"
                :class="activeCategories.includes('immersives') ? 'li-active' : 'li-inactive'">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/gamer1.svg" alt="gamer1" />
              </li>
              <li @click="filterExperiences('DIY')"
                :class="activeCategories.includes('DIY') ? 'li-active' : 'li-inactive'">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/diy.svg" alt="diy" />
              </li>
              <li @click="filterExperiences('oenologiques')"
                :class="activeCategories.includes('oenologiques') ? 'li-active' : 'li-inactive'">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/glass-with-wine.svg" alt="glass-with-wine" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="address-card-phone-wrapper" v-if="isPhone">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column">
              <p class="card-title raleway-semi-p16 mb-1">{{ addressBook.lodging.name }}</p>
              <p class="raleway-reg-p15">A partir de <strong>{{ addressBook.lodging.lowest_price }}€ </strong>/ nuit</p>
              <!-- <p class="raleway-reg-p15 mb-0">{{addressBook.lodging.address}}</p> -->
            </div>
            <div>
              <button @click="navigateToReservation" class="hortense-btn-primary mt-0">Reservez</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="address-card-wrapper" id="address-card-sticky" v-if="!isPhone">
        <div class="card" v-if="!isPhone">
          <div class="card-image">
            <img :src="addressBook.lodging_photo_url" :alt="addressBook.lodging.name" class="card-img-top" />
          </div>
          <div class="card-body">
            <h5 class="card-title">{{ addressBook.lodging.name }}</h5>
            <p class="raleway-reg-p15">{{ addressBook.lodging_catch_sentence }}</p>
            <p class="raleway-reg-p15">A partir de {{ addressBook.lodging.lowest_price }}€ / nuit</p>
            <button @click="navigateToReservation" class="hortense-btn-primary">Reservez</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import fetcher from "../../packs/shared/api.js";
import ExperienceMap from '../../components/ExperienceMap.vue';
import CardExperienceCarnet from "../../components/cards/CardExperienceCarnet.vue";
import ExperienceMapShow from "../../components/ExperienceMapShow.vue";
import ExperienceMapModal from "../../components/ExperienceMapModal.vue";
export default {
  name: "CarnetAddress",
  props: {
    addressBook: {
      type: Object,
      required: true
    },
    user: Object,
  },
  data() {
    return {
      selectedExperience: '',
      activeCategories: [],
      allExperiences: {},
      experiencesByCategory: {},
      categories: [
        { display: 'Les expériences culturelles', backend: 'Culturelles' },
        { display: 'Les expériences au naturel', backend: 'Au Naturel' },
        { display: "Les expériences au bord de l'eau", backend: "Au bord de l'eau" },
        { display: 'Les expériences sportives', backend: 'Sportives' },
        { display: 'Les expériences immersives', backend: 'Immersives' },
        { display: 'Les expériences culinaires', backend: 'Culinaires' },
        { display: 'Les expériences DIY', backend: 'Diy' },
        { display: 'Les expériences oenologiques', backend: 'Oenologiques' }
      ],
      currentPage: {},
      itemsPerPage: 6,
      showMap: false,
      categoryMarkers: {},
      markers: [],
      previous_lodging: [],
      categoryDescriptions: {},
      dataFetched: false,
      showMapfind: false,
      experienceselected: 0,
      lodging: {
        type: Object,
        required: true
      },
      currentExperiance : '',
      selectedExperienceMarker :[],
      mapObserver: null,
      showExperienceMap: false,
      selectedExperienceForMap: null,
      scrolled: false,
      showFullContent: false
    };
  },
  mounted() {
    if (!this.dataFetched) {
      this.getExperiencesForCategoryRow();
      this.fetchAllExperiences();
      this.dataFetched = true;
    }
    console.log("addressBook.lodging", this.addressBook.lodging)
    this.showMap = true;
    window.addEventListener("scroll", this.handleScroll);
    this.setupMapObserver();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  components: {
    CardExperienceCarnet,
    ExperienceMap,
    ExperienceMapShow,
    ExperienceMapModal
  },
  methods: {
    scrollToExperienceMap() {
      const targetElement = document.getElementById('map');
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    showExperienceMapModal() {
      this.lodging = this.addressBook.lodging;
      this.selectedExperienceForMap = null; // or set to a specific experience if needed
      this.showExperienceMap = true;
    },
    displayCategoryMap(category) {
      let result;
      switch (category) {
        case "Les expériences culturelles":
          result = "culturelles";
          break;
        case "Les expériences au naturel":
          result = "au naturel";
          break;
        case "Les expériences au bord de l'eau":
          result = "au bord de l'eau";
          break;
        case "Les expériences sportives":
          result = "sportives";
          break;
        case "Les expériences immersives":
          result = "immersives";
          break;
        case "Les expériences culinaires":
          result = "culinaires";
          break;
        case "Les expériences DIY":
          result = "diy";
          break;
        case "Les expériences oenologiques":
          result = "oenologiques";
          break;
        default:
          result = "";
          break;
      }
      this.currentExperiance = category

      console.log("this.categoryMarkersthis.categoryMarkers", this.categoryMarkers[result])
      this.selectedExperienceMarker = this.categoryMarkers[result]
      this.showMapfind = !this.showMapfind;
    },
    handleScroll() {
      const card = document.getElementById("address-card-sticky");
      const hero = document.getElementById("heroSection");
      const footer = document.getElementById("footer");
      const map = document.getElementById("map")

      if (!card || !hero || !footer || !map) return;

      const heroBottom = hero.getBoundingClientRect().bottom;
      const footerTop = footer.getBoundingClientRect().top;
      const mapTop = map.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      const shouldShow = heroBottom < 0 && mapTop > windowHeight;

      if (shouldShow) {
        card.style.position = "fixed";
        card.style.top = "8rem";
        card.style.right = "0.3rem";
        card.style.zIndex = "1000";
        card.classList.add("visible");
      } else {
        card.classList.remove("visible");
      }

      const top =	window.pageYOffset;
      const bottom = document.body.scrollHeight - (window.innerHeight + window.scrollY);
      const footer_height = document.getElementById('p-footer')?.offsetHeight;
      if (top > 500 && bottom > footer_height) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
    navigateToReservation() {
      const url = '/reservation-hotel/' + this.addressBook.lodging.slug;
      window.open(url, '_blank');
    },
    filterExperiences(selectedCategory) {
      this.selectedExperience = selectedCategory;
      if (this.activeCategories.includes(selectedCategory)) {
        this.activeCategories = [];
        this.fetchAllExperiences();
      } else {
        this.activeCategories = [selectedCategory];
        this.fetchExperiencesByCategory(selectedCategory);
      }
      // this.$set(this.currentPage, selectedCategory, 1);   
      // this.fetchExperiencesByActiveCategories();
    },
    fetchExperiencesByActiveCategories() {
      if (this.activeCategories.length === 0) {
        this.fetchAllExperiences();
      } else {
        this.experiencesByCategory = {};
        this.activeCategories.forEach(async (category) => {
          await this.fetchExperiencesByCategory(category);
        });
      }
    },
    selectCard(attr) {
      this.experienceselected = attr - 1;
      this.selectedMarker = !this.selectedMarker;
    },
    selectCardMap(markerId) {
     
    },
    async fetchExperiencesByCategory(category) {
      try {
        const response = await fetcher.get(`/categories/${encodeURI(category)}/experiences/list?lodging_id=${this.addressBook.lodging.id}`);
        this.$set(this.experiencesByCategory, category, response.data);

        if (response.data.length > 0) {
          this.$set(this.categoryDescriptions, response.data[0].name, response.data[0].description);
        }
        this.previous_lodging = response.data;

        const newMarkers = this.markerMap();
        console.log(newMarkers);
        this.$set(this, 'markers', newMarkers);
      } catch (e) {
        console.error(e);
      }
    },
    pageRange(category) {
      const total = this.totalPages(category);
      const current = this.currentPage[category];
      const range = [];

      const start = Math.max(1, current - 2);
      const end = Math.min(total, current + 2);

      for (let i = start; i <= end; i++) {
        range.push(i);
      }

      if (start > 2) {
        range.unshift('...');
        range.unshift(1);
      } else if (start === 2) {
        range.unshift(1);
      }

      if (end < total - 1) {
        range.push('...');
        range.push(total);
      } else if (end === total - 1) {
        range.push(total);
      }

      return range;
    },
    changePage(category, page) {
      if (page === '...') return;
      this.$set(this.currentPage, category, page);
    },
    totalPages(category) {
      const experiences = this.experiencesByCategory[category] || [];
      // Filter out experiences without photo_key for accurate pagination
      const filteredExperiences = experiences.filter(experience => experience.photo_key);
      return Math.ceil(filteredExperiences.length / this.itemsPerPage);
    },
    paginatedExperiences(category) {
      const experiences = this.experiencesByCategory[category] || [];
      // Filter out experiences without photo_key
      const filteredExperiences = experiences.filter(experience => experience.photo_key);
      const startIndex = (this.currentPage[category] - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return filteredExperiences.slice(startIndex, endIndex);
    },

    async getExperiencesForCategoryRow() {
      try {
        const allLodging = []; // Array to hold all lodging data

        for (const category of this.categories) {
          const response = await fetcher.get(`/categories/${encodeURI(category.backend)}/experiences/list?lodging_id=${this.addressBook.lodging.id}`);

          this.$set(this.allExperiences, category.display, response.data);
          this.$set(this.currentPage, category.display, 1);

          if (response.data.length > 0) {
            const categoryInfo = response.data[0];
            this.$set(this.categoryDescriptions, categoryInfo.name, categoryInfo.description);

            allLodging.push(response.data);
          }
        }

        this.previous_lodging = allLodging.flat();
      } catch (e) {
        console.error(e);
      }
    },

    async fetchAllExperiences() {
      try {
        const allLodging = [];

        for (const category of this.categories) {
          const response = await fetcher.get(`/categories/${encodeURI(category.backend)}/experiences/list?lodging_id=${this.addressBook.lodging.id}`);
          this.$set(this.experiencesByCategory, category.display, response.data);

          if (response.data.length > 0) {
            const categoryInfo = response.data[0];
            this.$set(this.categoryDescriptions, categoryInfo.name, categoryInfo.description);

            allLodging.push(response.data);
          }
        }
        const result = {};
        const categoryWiseData = allLodging.forEach(array => {
          array.forEach(item => {
            const category = item.category_name;

            if (!result[category]) {
              result[category] = [];
            }

            result[category].push([item.longitude, item.latitude, item.id, item.category_name]);
          });
        });
        this.categoryMarkers = result;
        console.log("CategoryMarkers:", this.categoryMarkers);
        this.previous_lodging = allLodging.flat() ;
        this.markers = this.markerMap();
      } catch (e) {
        console.error(e);
      }
    },
    scrollToElement(categoryClass) {
      let sanitizedClass = categoryClass
        .replace(/[^a-zA-Z]/g, '')
        .toLowerCase();
      const el = document.querySelector(`.lesexpriences${sanitizedClass}`);

      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    classifyCategory(category) {
      return category.replace(/[^a-zA-Z]/g, '') 
        .toLowerCase();
    },
    async selectOption(e) {
      const clickedAnchor = e.target.closest(".exp-category");
      if (!clickedAnchor) return;

      const activeEl = document.querySelector(".exp-category.active");
      if (activeEl) {
        activeEl.classList.remove("active");
      }

      clickedAnchor.classList.add("active");
      this.SelectedOption = clickedAnchor.querySelector("[data-value]").dataset.value;

      if (this.SelectedOption) {
        await this.fetchExps(this.SelectedOption);
      } else {
        this.experiencesFiltered = [];
      }
    },
    isUserConnected() {
      return this.user ? this.user : {};
    },
    displayMap() {
      this.showMap = !this.showMap;
      this.markers = this.markerMap();
    },
    markerMap() {
      const markers = [];
      this.previous_lodging.map((el) => {
        markers.push([el.longitude, el.latitude, el.id, el.category_name]);
      });
      return markers;
    },
    displayMapfind() {
      this.markers = JSON.parse(JSON.stringify(this.markerMap()));
      this.showMapfind = !this.showMapfind;
      if (event.currentTarget.className === "hortense-btn-primary") {
        setTimeout(function () {
          document.querySelectorAll(".marker").forEach((marker) => {
            marker.style.display = "none";
            marker.style.pointerEvents = "none";
          });
          document.querySelectorAll(".marker")[0].style.display = "block";
        }, 1);
      }
    },
    showExperienceOnMap(experience) {
      // Create marker for the specific experience
      this.selectedExperienceMarker = [[experience.longitude, experience.latitude, experience.id, `les expériences ${experience.category_name}`]];
      this.currentExperiance = `les expériences ${experience.category_name}`;
      this.showMapfind = true;
    },
    setupMapObserver() {
      if (!this.isPhone) return;

      const mapWrapper = document.getElementById('map-container-exp');
      const phoneWrapper = document.querySelector('.address-card-phone-wrapper');
      const topBar = document.querySelector('.top-bar');
      const whatsappBtn = document.getElementById('whatsapp-button');

      if (!mapWrapper || !phoneWrapper) return;

      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };

      this.mapObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Map is in view, hide phone wrapper and top bar
            phoneWrapper.style.display = 'none';
            if (topBar) {
              topBar.style.display = 'none';
            }
            if (whatsappBtn) {
              whatsappBtn.style.display = 'none';
            }
          } else {
            // Map is out of view, show phone wrapper and top bar
            phoneWrapper.style.display = 'block';
            if (topBar) {
              topBar.style.display = 'block';
            }
            if (whatsappBtn && this.scrolled) {
              whatsappBtn.style.display = 'block';
            }
          }
        });
      }, options);

      this.mapObserver.observe(mapWrapper);
    },
    toggleContent() {
      this.showFullContent = !this.showFullContent;
    },
  },
  computed: {
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    scrolled: {
      handler(newVal) {
        const whatsappBtn = document.getElementById('whatsapp-button');
        if (whatsappBtn) {
          whatsappBtn.style.display = newVal ? 'block' : 'none';
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-container {
  background-color: #efefef;
  margin-bottom: 3rem;
}

img {
  width: 100%;
  height: 100%;
}

.img-wrapper {
  height: 400px;
  position: relative;
}

.img-wrapper img.address-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.address-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-top: 2rem;
}

.expe-btn {
  max-width: 368px;
  margin: 0 auto;

  a {
    cursor: pointer;
  }
}

.address-card-wrapper {
  width: 230px;
  transition: all 0.3s ease-in-out;
}

.address-card-wrapper .card {
  border-radius: 4px;
  background: #fff 0 0 no-repeat padding-box;
  box-shadow: 1px 2px 6px rgba(0, 0, 0, .1607843137254902);
  transition: all .3s ease-in-out;
}

.address-card-wrapper .card .card-body {
  padding: 0.8rem;
}

.address-card-wrapper .card-image img {
  padding: 10px;
  object-fit: cover;
}

.address-card-wrapper .card .card-image {
  height: 256px;
}

.address-card-wrapper .card .hortense-btn-primary {
  padding: 10px 30px;
}

.adddress-image {
  height: 550px;

  img {
    object-fit: cover;
  }
}

.address-content {
  padding-left: 1.5rem;

  h1 {
    font-size: 28px;
    margin: 1em 0rem;
  }

  p:first-child {
    max-width: 225px;
    margin: 0 auto;
  }
}

.desti-header {
  max-width: 65%;
  margin: 0 auto;

  a {
    text-decoration: underline;
  }
}

.circle-image {
  bottom: -203px;
  left: -53px;
  max-width: 33%;
}

.exp-card div:last-child {
  border: 1px solid black;
  padding: 1rem;
}

#card-explodging .info-exp {
  border: 1px solid;
  height: 600px;
  padding: 2rem;
  padding-bottom: 0;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid lightgray;
  padding-bottom: 7rem;

  .btn {
    margin: 0 5px;
    border-radius: 3px;
    font-size: 14px;
    border-color: lightgrey;

    &.btn-success {
      background-color: #3b6152;
      color: white;
    }

    &:hover {
      background-color: #3b6152;
    }

    &:focus {
      box-shadow: none;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}

ul.icon-list {
  display: flex;
  justify-content: space-around;
  background: #efefef;
  padding-left: 0;

  li {
    list-style: none;
    background: #fff;
    margin: 1rem;
    padding: 0.5rem 2.4rem;

    &.li-active {
      background: #3b6152;
    }

    img {
      width: 100%;
      max-width: 57px;
      cursor: pointer;
    }
  }
}

.address-card-phone-wrapper {
  position: fixed;
  bottom: 0;
  z-index: 999;
  left: 0;
  right: 0;
}

@media (max-width: 768px) {
  .banner-container {
    padding: 1rem;
    margin-bottom: 1.5rem;
  }

  .menu-lodging .list-menu {
    margin-bottom: 0;
    overflow-y: hidden;

    .menu-item {
      padding-right: 1rem;

      a {
        width: max-content;
        display: block;
      }
    }
  }

  .menu-item {
    margin-bottom: 0.5rem;
  }

  .banner-container .col-md-4 {
    order: 1;
  }

  .address-content {
    padding-top: 3rem;
    padding-left: 0;
  }

  .adddress-image {
    height: 310px;
    margin-top: 2rem;
  }

  .img-wrapper {
    height: 310px;
  }

  .address-wrapper {
    margin-top: 1rem;
  }

  .address-content-wrapper {
    padding-top: 2rem;
  }

  .img-wrapper .circle-image {
    bottom: -121px;
    left: -53px;
    max-width: 33%;
  }


  .exp-card {
    padding: 0.5rem;
  }

  .desti-header {
    max-width: 100%;
  }

  .pagination-container {
    gap: 3px;
    flex-wrap: wrap;
    padding-bottom: 2rem;
    margin-top: .7rem !important;

    .btn {
      margin: 0.25rem 0;
    }
  }

  .address-card-wrapper {
    display: none;
  }

  ul.icon-list {
    flex-wrap: wrap;
    justify-content: center;

    li {
      padding: .4rem;
      margin: .3rem;
    }
  }

  #category-row {
    .row {
      flex-wrap: nowrap;
      overflow-y: scroll;
    }
  }

  .expe-btn {
    max-width: 100%;

    .hortense-btn-primary {
      padding: 16px;
    }
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.li-active img {
  filter: brightness(0) invert(1);
}

.li-inactive img {
  filter: invert(0);
  /* This will keep the original color of the SVG */
}

#address-card-sticky {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

#address-card-sticky.visible {
  opacity: 1;
  pointer-events: auto;
}

.address-container {
    width: 100% !important;
  }

@media (min-width: 768px) {
  .address-container {
    width: 85% !important;
  }
}


// .category-icon-wrapper {
//   position: relative !important;
//   z-index: 5 !important
// }



#map {
      margin:auto  !important;
      margin-top: -21px  !important;
}

#map-wrapper {
  padding: 0px !important;
}

.address-show {
  cursor: pointer;
  color: black;
  text-decoration: underline !important;
}

.nav-lodging {
  position: absolute;
  bottom: 0;
  background-color: black;
  color: white;
  display: flex;
  padding: 10px 10px 12px 30px;
  justify-content: space-between;
  width: 100%;
  z-index: 10;

  .menu-lodging {
    display: flex;
    overflow-x: auto;
    width: 100%;

    .list-menu {
      list-style: none;
      display: flex;
      justify-content: space-evenly;
      width: 100%;
      align-items: baseline;
      flex-wrap: wrap;
      gap: 40px;

      @media screen and (min-width: 800px) and (max-width: 1565px) {
        gap: 5px;
      }

      .menu-item {
        position: relative;
        padding-right: 3rem;
        margin-top: 10px;
        white-space: nowrap;
        cursor: pointer;
        
        text-transform: uppercase;
        border-right: 1px solid white;

        a {
          text-decoration: none;
          color: white;
        }

        &:hover {
          font-weight: 600;
        }

        &.selected {
          border-bottom: 5px solid #3b6152;
        }
      }

      .menu-item-no-border {
        border-right: none !important;
      }
    }
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .nav-lodging {
    margin-top: 1rem;
    width: 100%;
    height: 6vh;

    .menu-lodging .list-menu {
      justify-content: start;
      gap: 5px;
      overflow-x: auto;
      flex-wrap: unset !important;

      .menu-item {
        margin-right: 5px;
        padding-right: 10px;
        flex-shrink: 0;

        a {
          font-size: 13px;
          white-space: nowrap;
        }
      }
    }
  }
}

.html-content-wrapper {
  position: relative;
}

.html-content {
  transition: all 0.3s ease;
}

.content-collapsed {
  max-height: 200px;
  overflow: hidden;
  position: relative;
}

.content-collapsed::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: linear-gradient(transparent, white);
  pointer-events: none;
}

.toggle-content-btn {
  background: none;
  border: none;
  color: #000;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  margin-top: 10px;
  padding: 0;
  font-family: inherit;
}

.toggle-content-btn:hover {
  color: #2d4a3d;
}

@media (max-width: 768px) {
  .content-collapsed {
    max-height: 150px;
  }
}

</style>
